import React from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';

import { BodyText, Image, theme } from '@sg/garnish';

import { type Props } from '../OrganizationLink.types';

// ─────────────────────────────────────────────────────────────────────────────

export const OrganizationLinkPressable = (props: Props) => {
  const { link, onPress } = props;

  return (
    <View style={styles.linkWrapper}>
      <TouchableOpacity accessibilityRole="button" onPress={onPress}>
        <BodyText sizeMatch={['16']}>{link.label}</BodyText>
      </TouchableOpacity>

      {link.icon ? (
        <Image
          style={styles.linkIcon}
          aria-label={link.label}
          source={{ uri: link.icon }}
          contentFit="contain"
        />
      ) : null}
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  linkWrapper: {
    minHeight: theme.spacing['6'],
    gap: theme.spacing['2'],
    flexDirection: 'row',
    alignItems: 'center',
  },
  linkIcon: {
    width: 32,
    height: 24,
  },
});
